import React from 'react';
import { Link } from "react-router-dom";

import sheetmetalmanufacturing from '../img/services/sheet-metal/sheet-metal-manufacturing.jpg';
import sheetmetalvideo from '../img/services/sheet-metal/sheet-metal-video.jpg';
import sheetmetalworking from '../img/services/sheet-metal/sheet-metal-working.jpg';
import sheetmetalworking1 from '../img/services/sheet-metal/sheet-metal-working1.jpg';
import sheetmetalworking2 from '../img/services/sheet-metal/sheet-metal-working2.jpg';
import sheetmetalworking3 from '../img/services/sheet-metal/sheet-metal-working3.jpg';
import sheetmetalworking4 from '../img/services/sheet-metal/sheet-metal-working4.jpg';
import sheetmetalworking5 from '../img/services/sheet-metal/sheet-metal-working5.jpg';
import sheetmetalworking6 from '../img/services/sheet-metal/sheet-metal-working6.jpg';
import sheetmetalworking7 from '../img/services/sheet-metal/sheet-metal-working7.jpg';
import sheetmetalworking8 from '../img/services/sheet-metal/sheet-metal-working8.jpg';
import sheetmetalworking9 from '../img/services/sheet-metal/sheet-metal-working9.jpg';
import sheetmetalworking10 from '../img/services/sheet-metal/sheet-metal-working10.jpg';

import metalCraftCatalogue  from '../catalogues/sheetmetal/finike-metal-craft-catalogue.pdf';

import metalcraftvideo from '../video/metalvideo.mp4';

function Sheetmetal() {
  return (
<div className="page-content">
  {/* INNER PAGE BANNER */}
  <div
    className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
    data-stellar-background-ratio="0.5"
    style={{
      backgroundImage:
        `url(${sheetmetalmanufacturing}) `
    }}
  >
    <div className="overlay-main bg-black opacity-07" />
    <div className="container">
      <div className="sx-bnr-inr-entry">
        <div className="banner-title-outer">
          <div className="banner-title-name">
            <h2 className="m-tb0">
              (SS-Sheet Metal) CNC Automatic Machines for Lighting, Battery,
              Inverter, UPS enclosures
            </h2>
            <p>
              State of the art manfuacturing facility for SS-Sheet ,MS-Sheet,
              Lazer Cut, Bending and Finishing on CNC Machines
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  {/* INNER PAGE BANNER END */}
  {/* SECTION CONTENT START */}
  <div className="section-full p-t80 p-b50 mobile-page-padding">
    <div className="container">
      {/* GALLERY CONTENT START */}
      <div className="row">
        <div className="col-lg-4 col-md-12 sticky_column">
          <div className="about4-section m-b20  p-a20">
            
            <div className="widget widget_services">
              <h4 className="widget-title"></h4>
              <ul>
                <li>
                  <Link to="/our-services/led-lights"></Link>
                </li>
                <li>
                  <Link to="/our-services/lithium-battery"></Link>
                </li>
                <li>
                  <Link to={metalCraftCatalogue}></Link>
                </li>
              </ul>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={metalCraftCatalogue}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Metal Craft Catalogue 
                </strong>
              </a>
            </div>
            
            {/*<div >
              <a
                href={metalCraftCatalogue}
                className="site-button-link"
                target="_blank"
              >
                Metal Craft Catalogue 
              </a>
            </div>*/}
          </div>
        </div>
        <div className="col-lg-8 col-md-12">
          <div className="section-content">
            <div className="service-single-block m-b30">
              <div className="sx-media">
                <img
                  src={sheetmetalworking}
                  alt=""
                />
              </div>
              <h3 className="m-t30 sx-tilte">
                The Durability and Versatility of Stainless Steel Sheet Metal
                from Spinoff Technopark Ltd.
              </h3>
              <p>
                Stainless steel has long been renowned for its exceptional
                properties, making it a material of choice across various
                industries. At Spinoff Technopark Ltd. we take pride in
                harnessing the power of stainless steel sheet metal to deliver
                robust solutions tailored to your needs.
              </p>
              <h4 className="m-t30 sx-tilte">
                Why Choose Stainless Steel Sheet Metal?
              </h4>
              <div className="single-service-list">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <ul className="list-angle-right anchor-line">
                      <li>Unmatched Durability</li>
                      <li>Superior Strength</li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <ul className="list-angle-right anchor-line">
                      <li>Aesthetic Appeal</li>
                      <li>Versatility in Applications</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="sx-media sx-img-effect zoom-slow">
                <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                  <img
                    src={sheetmetalvideo}
                    alt=""
                  />
                  <a
                    href={metalcraftvideo}
                    className="mfp-video play-now"
                     target='_blank'
                  >
                    <i className="icon fa fa-play" />
                    <span className="ripple" />
                  </a>
                </div>
              </div>
            </div>
            <div className="sx-accordion acc-bg-gray m-b30" id="accordion5">
              <div className="panel sx-panel">
                <div className="acod-head acc-actives">
                  <h6 className="acod-title">
                    <a
                      data-toggle="collapse"
                      href="#collapseOne5"
                      data-parent="#accordion5"
                    >
                      Why choose stainless steel for industrial applications?
                      <span className="indicator">
                        <i className="fa" />
                      </span>
                    </a>
                  </h6>
                </div>
                <div id="collapseOne5" className="acod-body collapse show">
                  <div className="acod-content p-tb15">
                    <p>
                      Stainless steel offers durability, corrosion resistance
                      and strength, crucial for robust industrial operations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="panel sx-panel">
                <div className="acod-head">
                  <h6 className="acod-title">
                    <a
                      data-toggle="collapse"
                      href="#collapseThree5"
                      className="collapsed"
                      data-parent="#accordion5"
                    >
                      How does stainless steel support sustainability efforts?
                      <span className="indicator">
                        <i className="fa" />
                      </span>
                    </a>
                  </h6>
                </div>
                <div id="collapseThree5" className="acod-body collapse">
                  <div className="acod-content p-tb15">
                    Stainless steel is recyclable, promoting environmental
                    responsibility while maintaining high performance and
                    durability.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 m-b30">
                <div className="sx-icon-box-wraper p-a30  center bg-white shadow">
                  <div className="sx-icon-box-lg inline-icon text-primary  m-b20 radius bg-secondry  scale-in-center">
                    <span className="icon-cell sx-text-primary">
                      <i className="flaticon-architect" />
                    </span>
                  </div>
                  <div className="icon-content">
                    <h4 className="sx-tilte">Manufacturing</h4>
                    <p>
                      Precision processes for durability, strength, and
                      aesthetic appeal
                    </p>
                    {/* <a href="#" class="site-button-link">Read More</a> */}
                  </div>
                </div>
              </div>
              <div className="col-md-6 m-b30">
                <div className="sx-icon-box-wraper p-a30  center bg-white shadow">
                  <div className="sx-icon-box-lg inline-icon text-primary  m-b20 radius bg-secondry  scale-in-center">
                    <span className="icon-cell sx-text-primary">
                      <i className="flaticon-ruler-1" />
                    </span>
                  </div>
                  <div className="icon-content">
                    <h4 className="sx-tilte">Solution</h4>
                    <p>
                      Versatile solution for durability, aesthetics, and
                      environmental sustainability
                    </p>
                    {/* <a href="#" class="site-button-link">Read More</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* GALLERY CONTENT END */}
    </div>
    {/* Similar projects START */}
    <div className="section-full p-tb80 bg-gray inner-page-padding">
      <div className="container">
        <div className="section-content">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-left">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: "url(/images/background/cross-line2.png)"
                }}
              >
                <h3 className="sep-line-one">SS-Sheet Metal Working</h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          <div className="work-carousel-outer">
            <div className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80">
              {/* COLUMNS 1 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={sheetmetalworking1}
                      alt=""
                    />
                    {/*<div className="figcaption">
                      <a
                        className="mfp-link"
                        href="/img/services/sheet-metal/sheet-metal-working1.jpg"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>*/}
                  </div>
                </div>
              </div>
              {/* COLUMNS 2 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={sheetmetalworking2}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              {/* COLUMNS 3 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={sheetmetalworking3}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              {/* COLUMNS 4 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={sheetmetalworking4}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 5 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                       src={sheetmetalworking5}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 6 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                       src={sheetmetalworking6}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 7 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={sheetmetalworking7}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 8 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                       src={sheetmetalworking8}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 9 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                       src={sheetmetalworking9}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 10 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                       src={sheetmetalworking10}
                      alt=""
                    />
                    {/*<div className="figcaption">
                      <a
                        className="mfp-link"
                        href="/img/services/sheet-metal/sheet-metal-working10.jpg"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Similar projects END */}
  </div>

</div>

  );
}

export default Sheetmetal;

